import React from 'react';
import { grey, magenta } from 'globals/colors';

interface FsXmarkInCircleIconProps {
  color?: string;
}

const FsXmarkInCircleIcon: React.FC<FsXmarkInCircleIconProps> = ({
  color = magenta.BRAND,
}) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.344541"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z"
        fill={grey.V4}
      />
      <path
        d="M12.4727 5.63884L5.7905 12.321"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M12.4711 12.3214L5.78898 5.63924"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default FsXmarkInCircleIcon;
